/**
 * Component: Mega Menu Collection
 * -----------------------------------------------------------------------------
 * - Shows simplified filters (currently - colors only) and product list
 * - Used in the header section.
 * @namespace MegaMenuCollection
 */

window.addEventListener('DOMContentLoaded', () => {
  const customElementName = 'mega-menu-collection';
  /**
   * Register element.
   */
  if ('customElements' in window && !customElements.get(customElementName)) {
    /**
     * Create MegaMenuCollection Class.
     */
    class MegaMenuCollection extends window.HTMLElement {
      /**
       * Initialise.
       */
      constructor() {
        super();

        this.setState();
      }

      /**
       * Set state variables.
       */
      setState() {
        let rootUrl = Shopify?.routes?.root;

        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }

        /* Selectors */
        this.productGridSelector = '[js-products-grid]';
        this.productItemSelector = '[js-simplified-product-item]';
        this.formSelector = '[js-simplified-filter-form]';
        this.singleFilterSelector = '[js-simplified-filter]';
        this.filtersBarSelector = '[js-simplified-filter-bar-filters]';

        /* Attributes */
        this.filterName = 'js-simplified-filter-name';
        this.filterValue = 'js-simplified-filter-value';

        /* Sections */
        this.sectionID = 'mega-menu-collection-html';

        /* Misc / Others */
        this.rootURL = rootUrl;
        this.form = this.querySelector(this.formSelector);
        this.collectionURL =
          this.querySelector('[js-collection-url]')?.getAttribute(
            'js-collection-url'
          ) || `${rootUrl}collections/all`;
      }

      /**
       * The element is now defined on the page, so run functionality.
       */
      connectedCallback() {
        this.init();
        this.setEventListeners();
      }

      /**
       * Set Event Listeners.
       */
      setEventListeners() {
        this.form?.addEventListener('change', this.handleFormChange.bind(this));
      }

      async renderFilters() {
        const alreadyRendered = Boolean(
          (window.pageType === 'collection' &&
            window.collection?.URL === this.collectionURL) ||
            this.form?.querySelector(this.filtersBarSelector)
        );

        if (alreadyRendered) {
          /* Assume that filters should be rendered by Liquid */
          return;
        }

        const URL = `${this.collectionURL}?section_id=${this.sectionID}`;

        try {
          const response = await fetch(URL);
          const responseText = await response.text();

          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );
          const targetElement = this.form;
          const sourceElement = html.querySelector(this.formSelector);

          if (!targetElement || !sourceElement) {
            console.warn(
              `Either "Target" or "Source" element (${this.formSelector}) wasn\'t found.`
            );

            return;
          }

          if (
            'replaceUniqueIdentifiers' in window &&
            typeof window['replaceUniqueIdentifiers'] === 'function'
          ) {
            window.replaceUniqueIdentifiers(sourceElement);
          }

          targetElement.innerHTML = sourceElement.innerHTML;
          // targetElement.replaceWith(sourceElement);
        } catch (error) {
          console.error(error);
        }
      }

      async renderProducts(url) {
        if (!url) {
          console.warn(
            '[mega-menu-collection]: No URL provided to render products.'
          );

          return;
        }

        this.setAttribute('state', 'loading');

        try {
          const response = await fetch(url);
          const responseText = await response.text();

          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          );

          const targetElement = this.querySelector(this.productGridSelector);
          const sourceElement = html.querySelector(this.productGridSelector);

          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.setAttribute('state', 'ready');
        }
      }

      handleFormChange(event) {
        let activeFilter = null;

        if (!event) {
          activeFilter = this.form?.querySelector(
            `${this.singleFilterSelector}:checked`
          );
        } else {
          activeFilter = event.target;

          // Get all input elements
          const inputs = this.form.querySelectorAll(this.singleFilterSelector);

          // Uncheck all inputs except the current
          inputs.forEach((input) => {
            if (input !== activeFilter) {
              input.checked = false;
            }
          });
        }

        if (!activeFilter) {
          console.warn('[mega-menu-collection]: No active filters found.');
          return;
        }

        const filterName = activeFilter.getAttribute(this.filterName);
        const filterValue = activeFilter.getAttribute(this.filterValue);

        const endpoint = new URL(window.location);
        const params = new URLSearchParams(endpoint);

        params.set('section_id', this.sectionID);
        params.set(filterName, filterValue);

        endpoint.pathname = this.collectionURL;
        endpoint.search = params.toString();

        this.renderProducts(endpoint);
      }

      async init() {
        try {
          await this.renderFilters();
          this.handleFormChange();
        } catch (error) {
          console.error(error);
        }
      }
    }

    customElements.define(customElementName, MegaMenuCollection);
  }
});
